import React from "react";
import { Phone } from "lucide-react";
import { PHONE_HREF } from "@/lib/constants";
import { track } from "@/lib/track";

/**
 * Mobile-only bottom "Appeler" bar. WhatsApp now has its own floating
 * circular bubble above this bar, so this bar is single-action and leaves
 * room on the right edge so the bubble can stay clickable.
 */
const FloatingMobileCTA = () => {
    return (
        <div
            data-testid="floating-mobile-cta"
            className="md:hidden fixed bottom-0 inset-x-0 z-30 shadow-[0_-4px_20px_rgba(0,0,0,0.12)]"
            role="region"
            aria-label="Action rapide"
        >
            <a
                href={PHONE_HREF}
                data-testid="floating-phone-button"
                onClick={() =>
                    track("phone_click", { location: "floating_mobile" })
                }
                className="block bg-brand-red text-white py-4 pr-24 pl-4 text-center font-bold text-base active:bg-brand-red-hover transition-colors"
            >
                <span className="inline-flex items-center gap-2">
                    <Phone className="w-5 h-5" />
                    Appeler maintenant
                </span>
            </a>
        </div>
    );
};

export default FloatingMobileCTA;
